import { useMemo } from 'react';

import type {
  ITestAccuracyDay,
  TestAccuracySection,
} from '@/feature/testAccuracy/types/testAccuracy';
import { TanStackTable } from '@/shared/components/data-display/TanStackTable';

import { getTestAccuracyDailyColumns } from './testAccuracyDailyColumns';

interface ITestAccuracyDailyTableProps {
  days: ITestAccuracyDay[];
  section: TestAccuracySection;
}

const TestAccuracyDailyTable = ({ days, section }: ITestAccuracyDailyTableProps) => {
  const columns = useMemo(() => getTestAccuracyDailyColumns(section), [section]);

  const cardHeader = (
    <h2 className='text-xs font-semibold uppercase tracking-wide text-gray-500 m-0'>
      Daily Breakdown
    </h2>
  );

  return (
    <TanStackTable<ITestAccuracyDay>
      data={days}
      columns={columns}
      getRowId={(row) => row.date}
      cardHeader={cardHeader}
      enableSearch={false}
      enablePagination
      pageSize={10}
      minHeight='0'
      emptyMessage='No data for this period.'
      resetStateOnDataChange={false}
    />
  );
};

export default TestAccuracyDailyTable;
